// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__wm5YT","speakerButton":"styles_speakerButton__EuNU2"};